const FormStepperRouter = {
    init(el) {
        this.el = el;
        this.bind();
        this.baseUrl = this.el.el.closest('section').attr('url');
        this.onLoad();
    },

    onLoad(){
        this.path = window.location.href.replace(WEB_ROOT+"/"+this.baseUrl+"/", '');

        if(this.path.length === 1){
            FormStepperRouter.goTo(this.path);
        }
        // else {
        //     history.replaceState({order: 1}, "Step 1",   WEB_ROOT + '/' + this.baseUrl + '/1');
        //     FormStepperRouter.goTo(1);
        // }
    },

    bind() {
        window.addEventListener("popstate", (event) => {
            FormStepperRouter.goTo(event.state.order);
        });
    },

    goTo: function (order) {
        this.el[this.el.component].show(order);
    },

    route(nmb) {
        let url = WEB_ROOT + '/' + this.baseUrl + '/' + nmb;

        if(this.el.current === nmb){
            history.replaceState({order: nmb}, "Step " + nmb,  url);
        } else {
            history.pushState({order: nmb}, "Step " + nmb,  url);
        }
    },
}

export default FormStepperRouter;